import { memo } from "react";
import { Avatar } from "antd";
import _get from "lodash/get";
import _isEmpty from "lodash/isEmpty";
import PropTypes from "prop-types";
import moment from "moment";
import DefaultLogo from "assets/images/logovietgrp.svg";
import UserStatusIndicator from "components/UserStatusIndicator";

const ChatPopupConversationCell = ({ data, onClick, isActive, currentUserId }) => {
  const messageCreatedDate = _get(data, "latestMessage.createdAt");
  const unseenMessages = _get(data, "unseenMessages");
  const user = _get(data, "users[0]", {});
  const avatar = _get(user, "userDetail.avatar") || DefaultLogo;
  const online = _get(user, "online", 0);
  const lastSeen = _get(user, "lastSeen", null);

  const latestSenderName =
    _get(data, "latestMessage.sender") !== currentUserId
      ? user.name
      : "Bạn";

  let latestMessage = _get(data, "latestMessage.text");
  if (!_isEmpty(_get(data, "latestMessage.attachments", []))) {
    latestMessage = `${latestSenderName} vừa gửi tệp`;
  } else if (_get(data, "latestMessage.type") === "product") {
    latestMessage = `${latestSenderName} vừa gửi sản phẩm`;
  }

  return (
    <div
      className={`chat-popup-conv-cell ${isActive ? "active" : ""} ${
        unseenMessages ? "unseen" : ""
      }`}
      onClick={onClick}
    >
      <div className="chat-popup-conv-avatar">
        <Avatar size={36} src={avatar} />
        <UserStatusIndicator online={online} lastSeen={lastSeen} size="sm" />
      </div>
      <div className="chat-popup-conv-info">
        <div className="chat-popup-conv-name">
          <span className="name">{user.name}</span>
          <span className="time">
            {messageCreatedDate
              ? moment(messageCreatedDate).fromNow()
              : ""}
          </span>
        </div>
        <div className="chat-popup-conv-preview">
          {latestMessage && (
            <span className={unseenMessages ? "bold" : ""}>
              {latestMessage}
            </span>
          )}
          {unseenMessages > 0 && (
            <span className="chat-popup-conv-badge">{unseenMessages}</span>
          )}
        </div>
      </div>
    </div>
  );
};

ChatPopupConversationCell.propTypes = {
  data: PropTypes.object.isRequired,
  onClick: PropTypes.func,
  isActive: PropTypes.bool,
  currentUserId: PropTypes.string,
};

export default memo(ChatPopupConversationCell);
